import React, { useCallback, useEffect, useState } from 'react'
import useApi from '../../hooks/useApi'
import { Email } from '../../types/EmailType'

export const HistoricMail = () => {

    const api = useApi()

    const [mails, setMails] = useState<Email[]>()

    const loadHistoric = useCallback(async () => {
        await api.get("/admin/email").then(res => {
            setMails(res.data);
        }).catch(console.log)
    }, [api, setMails])

    useEffect(() => {
        loadHistoric()
    }, [loadHistoric])

    return (
        <div className=''>
            <div className='grid grid-cols-12'>
                <div className='col-span-2'><strong>Data de envio</strong></div>
                <div className='col-span-4'><strong>Assunto</strong></div>
                <div className='col-span-4'><strong>Grupo</strong></div>
            </div>

            {mails?.map(item => (
                <div className='grid grid-cols-12 bg-white'>
                    <div className='col-span-2'>{item.created_at}</div>
                    <div className='col-span-4'>{item.subject}</div>
                    <div className='col-span-4'>{item.group.map(g => (
                        <div>{g.name}</div>
                    ))}</div>
                </div>
            ))}


        </div>
    )
}